<template>
<div>
    <section class="pt-12 pt-md-14 mt-n11 bg-primary">
    </section>
    <section class="pt-8 pt-md-11 pb-12">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md">
                    <nav v-if="post.title" class="mb-4 small">
                        <router-link to="/blog" class="text-muted text-decoration-none">Blog</router-link>
                        <span class="text-muted mx-1">&gt;</span>
                        <span>{{ post.title }}</span>
                    </nav>
                    <h1 class="display-4 mb-2">{{ post.title }}</h1>
                    <p class="text-muted mb-8" v-if="post.published">{{ formatDate(post.published) }}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-12 blog-content" v-html="post.html_content"></div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { nextTick } from 'vue';

export default {
    data() {
        return {
            post: {}
        }
    },
    created() {
        this.get(this.$route.params.slug)
    },
    methods: {
        formatDate(d) {
            return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        },
        get(slug) {
            this.$services.BlogPost().get({slug}).then(resp => {
                this.post = resp.body
                nextTick(() => {
                    const meta = { title: this.post.title }
                    if (this.post.meta_description) {
                        meta.description = this.post.meta_description
                    }
                    if (this.post.meta_keywords) {
                        meta.keywords = this.post.meta_keywords
                    }
                    this.$methods.updateSEOMeta(meta, '/blog/' + slug)
                });
            })
        },
    },
    watch: {
        '$route.params.slug'(slug) {
            this.get(slug)
        }
    }
}
</script>

<style scoped>
.blog-content :deep(pre) {
    background: #1e1e1e;
    border-radius: 6px;
    padding: 1.25rem;
    margin-bottom: 1.5rem;
    overflow-x: auto;
    white-space: pre;
}

.blog-content :deep(pre code) {
    display: block;
    font-size: 0.85rem;
    line-height: 1.6;
    white-space: pre;
}

.blog-content :deep(table) {
    width: 100%;
    margin-bottom: 1.5rem;
    border-collapse: collapse;
}

.blog-content :deep(table th),
.blog-content :deep(table td) {
    padding: 0.75rem;
    border: 1px solid #dee2e6;
    text-align: left;
}

.blog-content :deep(table th) {
    font-weight: 600;
    background-color: #f8f9fa;
}

.blog-content :deep(table tr:nth-child(even)) {
    background-color: #f8f9fa;
}
</style>
